import { initializeApp } from "firebase/app";
import {getFirestore} from '@firebase/firestore';
import 'firebase/compat/database';
import firebase from 'firebase/compat/app';

var firebaseConfig = {
  apiKey: "AIzaSyBiq7MXLMojR1YaLlafhZVDWPtZchKD1cw",
  authDomain: "rachnadigifilms.firebaseapp.com",
  databaseURL: "https://rachnadigifilms.firebaseio.com",
  projectId: "rachnadigifilms",
  storageBucket: "rachnadigifilms.appspot.com",
  messagingSenderId: "1003543551817",
  appId: "1:1003543551817:web:ece61d4a08ba309dab0498",
  measurementId: "G-VMGNF89RWZ"
};

// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

// export default firebase;


// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const dataRef = firebase.database();